import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../../auth/aad/config';

export function createAADInstance() {
  const inst = new PublicClientApplication(msalConfig);

  return inst;
}
